import { Component, OnInit } from '@angular/core';
import {  MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import utilityCommon from 'app/core/utility/utility-common';
// imported cookie service

import { CookieService } from 'ngx-cookie-service';
@Component({
  selector: 'cz-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicyComponent implements OnInit {
  // boolean variable delaration
  public isEnglish: boolean = false;
  constructor(private readonly _cookieService: CookieService, private _translateService: TranslateService,
              private readonly _snackBar: MatSnackBar) {
    // checking condition for culture(cookie) value is Englishh to update boolean value
    if (['en'].includes(this._cookieService.get('Culture'))) {
      this.isEnglish = true;
    }
  }

  public ngOnInit():void {
  }
  public downloadPDF(): void {
    this.showSnackBar(this._translateService.instant('$pdf_download'));
    utilityCommon.pdfPrivacyDownloadinSafari(1);
  }

  public showSnackBar(message: string): void {
    this._snackBar.open(message, undefined, {
      duration: 5000,
    });
  }
}
